"use client"
import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { format } from "date-fns"

export type Billings = {
    asset_id: string,
    customer_name: string
    registration: string
    client_name: string
    loan_id: string
    billing_date: Date
    created_at: Date
    updated_at: Date
    beacon:string
}
export const billingsColumns = (): ColumnDef<Billings>[] => [

    {
        accessorKey: "asset_id",
        header: ({ column }) => {
            return (
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                >
                    Asset Id
                    <ArrowUpDown className="ml-2 h-4 w-4" />
                </Button>
            )
        },
    },
    {
        accessorKey: "beacon",
        header: ({ column }) => {
            return (
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                >
                    Beacon cid
                    <ArrowUpDown className="ml-2 h-4 w-4" />
                </Button>
            )
        },
    },
    {
        accessorKey: "customer_name",
        header: "Customer Name",
    },
    {
        accessorKey: "registration",
        header: "Registration",
    },
    {
        accessorKey: "client_name",
        header: "Client Name",
    },
    {
        accessorKey: "loan_id",
        header: "Loan Id",
    },

    {
        accessorKey: "created_at",
        header: ({ column }) => {
            return (
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                >
                    Created At
                    <ArrowUpDown className="ml-2 h-4 w-4" />
                </Button>
            )
        },
        cell: ({ row }) => {
            const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
            return <span>{formattedDate}</span>;
        },
    },
    {
        accessorKey: "updated_at",
        header: ({ column }) => {
            return (
                <Button
                    variant="ghost"
                    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                >
                    Updated At
                    <ArrowUpDown className="ml-2 h-4 w-4" />
                </Button>
            )
        },
        cell: ({ row }) => {
            const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss')
            return <span>{formattedDate}</span>;
        },
    },
    {
        accessorKey: "billing_date",
        header: ({ column }) => {
          return (
            <Button
              variant="ghost"
              onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            >
              Billing Status
              <ArrowUpDown className="ml-2 h-4 w-4" />
            </Button>
          );
        },
        cell: ({ row }) => {
          let billing_date = row.original.billing_date;
          let formattedDate = billing_date
            ? format(new Date(billing_date), 'yyyy-MM-dd HH:mm:ss')
            : undefined;
            
          return formattedDate ? (
            <span>{formattedDate}</span>
          ) : (
            <span className="  px-2 bg-red-500 text-white  rounded-full">Not Billed</span>
          );
        },
      },
]
